import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../modules/auth";
import { Spinner } from "../framework/widgets";

export const TouPageWrapper = () => {
  const [params] = useSearchParams();
  const { user } = useAuth();

  const type = params.get("type");
  const redirectTo = params.get("redirectTo") || "/dashboard";

  useEffect(() => {
    if (!type || !user?.email) return;

    if (type === "tou") {
      const redirectUrl =
        `/api/JGU/TOU-Redirect` +
        `?email=${user.email}` +
        `&redirectTo=${redirectTo}`;

      window.location.replace(redirectUrl);
    }
  }, [type, redirectTo, user?.email]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <h4><Spinner className="mx-3"/> please wait...</h4>
    </div>
  );
};
